/**
 * useFearMoment - a passing moment for a brother's life signs (Squad Mode stage 8, D21): a failed Fear test plays for
 * four seconds. Its mark is the shaken penalty the dread test writes (`Pen:all=-10:<DoF>`, engine/exposureDread): one
 * more of them than before is the moment. Counted, never compared whole: the countdown ticks the rounds down every
 * round, and that is no new fright (the stage 8 review). A GM's hand-typed "all -10 for N rounds" reads the same - the
 * table has no other mark of a failed Fear test. Never replayed (`usePassing`).
 *
 * (A psyker's power is the other moment the rulings name; nothing at the table marks a power used yet, so it waits
 * for one - recorded in wip.md.)
 *
 * @returns the moments playing now
 */
import usePassing from './usePassing';
import type { Moment } from '../../engine/plate/lifeSigns';

const shakenCount = (conditions: readonly string[]) =>
  String(conditions.filter((c) => c.startsWith('Pen:all=-10:')).length);
const more = (before: string, now: string) => Number(now) > Number(before);
const NONE: Moment[] = [];
const FEAR: Moment[] = ['fear'];

export default function useFearMoment(conditions: readonly string[]): Moment[] {
  return usePassing(shakenCount(conditions), more, 4000) ? FEAR : NONE;
}
